import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <div className="absolute navbar bg-base-100 z-10 bg-transparent hover:bg-white hover:bg-opacity-10 ">
      <ul className="flex justify-between inline-block text-white  text-lg w-full px-40 menu menu-horizontal">
        <Option main={{ to: "/teccem", text: "Home" }} />
        <Option
          main={{ to: "/teccem/laboratory", text: "Laboratory" }}
          submenu={[
            { to: "/teccem/parts", text: "Parts" },
            { to: "/teccem/laboratory/notebook", text: "Notebook" },
            { to: "/teccem/safety", text: "Safety Project" },
          ]}
        ></Option>
        <Option main={{to: "/teccem/description", text: "Project description"}} 
            submenu={[
              { to:"/teccem/proof-of-concept", text:"Proof of concept"},
              { to:"/teccem/engineering", text:"Engineering"},
              { to:"/teccem/software", text:"Software"},
              { to:"/teccem/hardware", text:"Hardware"},
              { to:"/teccem/results", text:"Results"},
              { to:"/teccem/implementation", text:"Implementation"},
              { to:"/teccem/model", text:"Model"},
              { to:"/teccem/measurement", text:"Measurement"},
            ]} />

        <Option
          main={{ to: "/teccem/social-impact", text: "Social Impact" }}
          submenu={[
            { to: "/teccem/human-practices", text: "Integrated Human Practices" },
            { to: "/teccem/education", text: "Education" },
            { to: "/teccem/communication", text: "Communication" },
            { to: "/teccem/sustainable", text: "Sustainable" },
          ]}
        ></Option>
        <Option main={{ to: "/teccem/team", text: "Team" }}
          submenu={[
            {to:"/teccem/collaborations", text:"Collabs"},
            {to:"/teccem/attributions", text:"Attributions"},
            {to:"/teccem/contribution", text:"Contributions"},
            {to:"/teccem/partnership", text:"Partnerships"},
            {to:"/teccem/artcompany", text:"Art Company"},

          ]}
        />


        <Option main={{ to: "/teccem/awards", text: "Awards" }} />
      </ul>
    </div>
  );
}

function ArrowDownSvg() {
  return (
    <svg
      className="fill-current inline"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
    </svg>
  );
}

function Option(props) {
  if (props.submenu == null || props.submenu.isEmpty) {
    return (
      <li>
        <a>
          <Link to={props.main.to}>{props.main.text}</Link>
        </a>
      </li>
    );
  } else {
    return (
      <li>
        <a>
          <Link to={props.main.to}>
            {props.main.text} {<ArrowDownSvg />}
          </Link>
        </a>
        <ul className=" bg-white text-black ">
          {props.submenu.map(function (it) {
            return (
              <li className="inline-block">
                <Link to={it.to}>
                  <a>{it.text}</a>
                </Link>
              </li>
            );
          })}
        </ul>
      </li>
    );
  }
}
